module.exports = __webpack_public_path__ + "school/img/news_bg.7844d427.jpg";